import { render, staticRenderFns } from "./Plugin.vue?vue&type=template&id=72ce7c4c&"
import script from "./Plugin.vue?vue&type=script&lang=js&"
export * from "./Plugin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports